import { ReactNode, ReactElement } from "react";

import { Icon, IconVariant } from "_/components/icon";
import { Spinner } from "_/components/spinner";

import * as S from "./styled";

export type AlertKind = "warning" | "info" | "success" | "error" | "muted";

type AlertProps = {
  kind?: AlertKind;
  children: ReactNode;
  icon?: IconVariant;
  spinner?: boolean;
  title?: string;
  className?: string;
};

export const Alert = ({
  kind = "info",
  children,
  icon,
  spinner,
  title,
  className,
}: AlertProps): ReactElement => {
  // Default icons for each kind
  const defaultIcons: Record<AlertKind, IconVariant> = {
    warning: "Warning",
    error: "Error",
    info: "Info",
    success: "CheckCircle",
    muted: "CheckCircle",
  };

  const iconVariant = icon ?? defaultIcons[kind];

  return (
    <S.Alert $kind={kind} className={className}>
      <S.AlertContent>
        <S.AlertIcon $kind={kind}>
          {spinner ? <Spinner size={20} /> : <Icon variant={iconVariant} />}
        </S.AlertIcon>
        <S.AlertBody>
          {title && <S.AlertTitle>{title}</S.AlertTitle>}
          <S.AlertText>{children}</S.AlertText>
        </S.AlertBody>
      </S.AlertContent>
    </S.Alert>
  );
};
